$(document).ready(function () {
	$(".opt").on("click", function () {
		// Remove all instances of selected
		$(".opt").removeClass("selected");
		// collect information to pass to form
		var rel = $(this).data("rel");
		//var did = $(this).data("id");

		//add class to selected
		$('[data-rel="' + rel + '"]').addClass("selected");

		// Update the hidden form
		//$("#in_opt").val(did);
		//$("#in_total").val('$'+pri);
       // $("#un_total").val(unp);

		// Update the pricing at top
		if (rel == 0) {
			$(".sub_price").html('$19.99');
            $("#in_opt").val('one_time');
			$("#sell_plan").val('');
			$("#interval_select").val('');

		} else {
			$(".sub_price").html('$15.99');
            $("#in_opt").val('0');
			// When subscription is selected update default selling plan to first plan available.
            if($("#sell_plan").val() == ''){
    			var freq_first = $(".freq_selected").data('id');
    			$("#sell_plan").val(freq_first);
    			$("#interval_select").val(freq_first);
            }
		}
	});

	$(".freq_drop").on("click", function () {
		$(".dropout").slideToggle();
	});

	$(".freq_opt").on("click", function () {
		var txt = $("b", this).html();
		var rel = $(this).data("id");
		$(".freq_selected b").html(txt);
		$("#sell_plan").val(rel);
		$("#interval_select").val(rel);
	});

	$("#sel_q").on("change", function () {
		var quan = $("#sel_q option:selected").val();
		if(quan >= 3){
			//quan = parseInt(quan)+1;
			$("#product_idd").val('36156617064601');
			$("#in_quan").val('1');
		}else{
			$("#product_idd").val('35950016856217');
			$("#in_quan").val(quan);
		}
	});

    $(".addtocart").on("click",function(e){
        e.preventDefault();

		var quan = $("#sel_q option:selected").val();
		var price = $(".sub_price").html().replace('$','');
		var tot_price = price * quan;



		dataLayer.push({ 'ecommerce': null });
		dataLayer.push({
		'event': 'add_to_cart',
		'ecommerce': {
				'items': [
					{
					'item_id': '35950016856217',
					'item_name': 'Joint Mud',
					'item_brand': 'Greek Wellness',
					'item_category': 'Supplement',
					'item_variant': '1680',
					'item_quantity': quan,
					'currency': 'usd',
					'price': tot_price
					}
				]
			}
		});

		//console.log($(".shopify-product-form").serializeArray());
		/*var bold = $("#in_opt").val();
		var quan = $("#in_quan").val();
		var freq = $("#in_freq").val();

		if(bold == 2 || bold == '2'){
        	if(quan == 3 || quan == 4){
				var url = 'https://natural-colon.myshopify.com/tools/checkout/buy_button/add_to_cart?p=5797845303461&v=36751972794533&g=175611&fn='+freq+'&ft=3&dp=$71.98&rdp=0.8&rup=7198';
                window.location.replace(url);
			}else{
        		$(".shopify-product-form").submit();
			}
		}else if(bold == 0 || bold == '0'){*/
			$(".remme").remove();
			$(".shopify-product-form").submit();
		//}
        
    })

    //var url = 'https://naturaljoint.myshopify.com/tools/checkout/buy_button/add_to_cart?p=3672882446389&v=28574156816437&g=119118&fn='+freq+'&ft=3&dp=$93.60&rdp=0.8&rup=9360&s=20&sd=1';
    //window.location.replace(url);
});